import { useEffect } from "react";

/**
 * Sets document.title, meta[name=description] and Open Graph tags for the current page.
 * Restores previous values on unmount so navigating back to Home returns the correct meta.
 */
export default function usePageMeta({ title, description, ogTitle, ogDescription }) {
  useEffect(() => {
    const prev = {
      title: document.title,
      description: document.querySelector('meta[name="description"]')?.getAttribute("content"),
      ogTitle: document.querySelector('meta[property="og:title"]')?.getAttribute("content"),
      ogDescription: document.querySelector('meta[property="og:description"]')?.getAttribute("content"),
      twTitle: document.querySelector('meta[name="twitter:title"]')?.getAttribute("content"),
      twDescription: document.querySelector('meta[name="twitter:description"]')?.getAttribute("content"),
    };

    const setMeta = (selector, value) => {
      const el = document.querySelector(selector);
      if (el && typeof value === "string") el.setAttribute("content", value);
    };

    if (title) document.title = title;
    if (description) setMeta('meta[name="description"]', description);
    if (ogTitle) setMeta('meta[property="og:title"]', ogTitle);
    if (ogDescription) setMeta('meta[property="og:description"]', ogDescription);
    if (ogTitle) setMeta('meta[name="twitter:title"]', ogTitle);
    if (ogDescription) setMeta('meta[name="twitter:description"]', ogDescription);

    return () => {
      document.title = prev.title;
      setMeta('meta[name="description"]', prev.description);
      setMeta('meta[property="og:title"]', prev.ogTitle);
      setMeta('meta[property="og:description"]', prev.ogDescription);
      setMeta('meta[name="twitter:title"]', prev.twTitle);
      setMeta('meta[name="twitter:description"]', prev.twDescription);
    };
  }, [title, description, ogTitle, ogDescription]);
}
